import React from 'react';
import Img from "../../images/services/rd/research.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Expert Software Research And Development Business Solutions For You</h2>
                        <p>Worried about whether your idea is a market fit? No worries. TekRevol understands the importance of software research and development to support an idea. Our research experts cover all your bases to support and allow you to turn your ideas and thoughts into reality. We take less time to deliver more value.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;